import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() { }
  public setItem(key: any, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  public getItem(key: any) {
    const item: string = localStorage.getItem(key);
    try {
      if (item) {
        return JSON.parse(item);
      }
    } catch (error) {
    }
    return null;
  }
  public removeItem(key: any) {
    localStorage.removeItem(key);
  }
}
